import type { ReactNode } from 'react';
import { WIDGET_COLORS } from '../constants/colors';

type Stat = {
  value: string;
  valueColor?: string;
  label: ReactNode;
};

type Props = {
  left: Stat;
  right: Stat;
  bg?: string;
  dividerColor?: string;
};

export function StatRow({ left, right, bg, dividerColor }: Props) {
  return (
    <div
      className="flex rounded-[10px] px-4 py-3.5 mt-1"
      style={{ backgroundColor: bg ?? WIDGET_COLORS.primaryLight }}
    >
      <div className="flex-1 flex flex-col">
        <span
          className="text-[22px] font-bold leading-[1.15]"
          style={{ color: left.valueColor ?? WIDGET_COLORS.primary }}
        >
          {left.value}
        </span>
        <span className="text-sm font-semibold uppercase tracking-[0.5px] text-gray-400 mt-0.5">
          {left.label}
        </span>
      </div>
      <div
        className="flex-1 flex flex-col pl-4"
        style={{ borderLeft: `1px solid ${dividerColor ?? WIDGET_COLORS.primaryDivider}` }}
      >
        <span
          className="text-[22px] font-bold leading-[1.15]"
          style={{ color: right.valueColor ?? WIDGET_COLORS.primary }}
        >
          {right.value}
        </span>
        <span className="text-sm font-semibold uppercase tracking-[0.5px] text-gray-400 mt-0.5">
          {right.label}
        </span>
      </div>
    </div>
  );
}
